import {BaseAnimationSetModel} from "./base-animation-set-model";

export class BaseTemplateAnimationSetModel extends BaseAnimationSetModel {}
